export function percentageDiff(a: number, b: number): number {
	if (a < 0 || b < 0) throw new Error('Require positive integers');
	if (a === 0) return b === 0 ? 0 : 100;
	return ((b - a) / a) * 100;
}